export enum EAROOperationCategoryEnum {
    OPEN_CATEGORY_A1,
    OPEN_CATEGORY_A2,
    OPEN_CATEGORY_A3,
    SPECIFIC_CATEGORY_STS01,
    SPECIFIC_CATEGORY_STS02,
    CERTIFIED_CATEGORY,
    UNKOWN,
}